module.exports = __webpack_public_path__ + "static/Japan-e4e6ee908922d666221a10eb83058e1b.jpg";